module.exports = __webpack_public_path__ + "static/troisEnfants-301cfe269e99f979f7b89d49a8cd5bbd.jpg";